var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { createContext, memo, useEffect, useMemo, useState, } from "react";
import { useGetAllDashletsQuery, useGetDashletsPreferencesUserQuery, useSaveDashletPreferencesMutation, useSaveModuleBuilderLayoutMutation, } from "@/store/api";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconMappingModule } from "../../default/menu/iconCorrespondance";
import { faSquare, faAdd } from "@fortawesome/pro-regular-svg-icons";
import { LoaderImage } from "@/utils/loader";
import copy from "fast-copy";
import EditDashlet from "./dashlets/edit";
import ChartsList from "./chart/chartsList";
import RowsDashlet from "./dashlets/rows";
// Ajout state global utile pour les widgets
export var DashletContext = createContext({});
export default function Dashboard(_a) {
    var _this = this;
    var _b;
    var widget = _a.widget, onChange = _a.onChange;
    var dashlets = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.dashlets;
    var allDashletsResponse = useGetAllDashletsQuery({}).data;
    // Pour permettre la mise à jour automatique
    var _c = useGetDashletsPreferencesUserQuery({}), preferenceDashlet = _c.data, loadGetDashlet = _c.isLoading;
    var _d = useState(dashlets || []), metaDashletLayout = _d[0], setMetaDashletLayout = _d[1];
    var _e = useState({}), dashletList = _e[0], setDashletList = _e[1];
    var t = useTranslation(["Home", "common"]).t;
    useEffect(function () {
        (allDashletsResponse === null || allDashletsResponse === void 0 ? void 0 : allDashletsResponse.data) &&
            setDashletList(Object.values(allDashletsResponse === null || allDashletsResponse === void 0 ? void 0 : allDashletsResponse.data));
    }, [allDashletsResponse]);
    useEffect(function () {
        var _a;
        if (preferenceDashlet) {
            setMetaDashletLayout((_a = preferenceDashlet === null || preferenceDashlet === void 0 ? void 0 : preferenceDashlet.data) === null || _a === void 0 ? void 0 : _a.dashlets);
        }
    }, [preferenceDashlet]);
    var _f = useState(false), isSelected = _f[0], setIsSelected = _f[1];
    var _g = useState(false), isEdit = _g[0], setIsEdit = _g[1];
    var uuidv4 = require("uuid").v4;
    var _h = useSaveDashletPreferencesMutation(), saveDashletPreferences = _h[0], _j = _h[1], dashletLoad = _j.isLoading, isError = _j.isError, data = _j.data;
    var _k = useSaveModuleBuilderLayoutMutation(), saveModuleBuilderLayoutMutation = _k[0], _l = _k[1], saveData = _l.data, tokenAccessError = _l.error, isSaveLoad = _l.isLoading;
    // Nouveau dashlet de type liste
    var addNewDashletPreference = function (mod, dahsletType, additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return __awaiter(_this, void 0, void 0, function () {
            var newDashlet_1, newMeta;
            return __generator(this, function (_a) {
                // Ajout data to row
                if (currentRow) {
                    newDashlet_1 = {
                        id: uuidv4(),
                        module: mod,
                        myItems: true,
                        component: "widget/dashlet/".concat(dahsletType),
                    };
                    if (additionalData) {
                        newDashlet_1 = __assign(__assign({ id: uuidv4(), module: mod, myItems: true }, additionalData), { component: "widget/".concat(dahsletType) });
                    }
                    newMeta = Object.values(metaDashletLayout).map(function (row) {
                        if (row.id === currentRow.id) {
                            return __assign(__assign({}, row), { meta: __spreadArray(__spreadArray([], row.meta, true), [newDashlet_1], false) });
                        }
                        else {
                            return __assign({}, row);
                        }
                    });
                    //setMetaDashletLayout({ ...newMeta });
                    updateDashletPreference(__assign({}, newMeta), true);
                }
                return [2 /*return*/];
            });
        });
    };
    // Save dashlet preference
    var updateDashletPreference = function (dashlets, isnew) {
        if (isnew === void 0) { isnew = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setIsSelected(false);
                        return [4 /*yield*/, saveDashletPreferences({
                                dashlets: dashlets,
                                isNew: isnew,
                            }).unwrap()];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Failed to save dashlet preference:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Get Dashlet Context
    var initialSettings = {
        rowId: "",
        isSelected: false,
        saved: false,
        module: "",
        dashlet: {
            id: "",
            filters: [],
            myItems: true,
            refresh: -1,
            displayRows: 3,
            title: "",
            view_defs: [],
        },
        filters: [],
        id: "",
    };
    var _m = useState(initialSettings), settings = _m[0], editedSettings = _m[1];
    // Sauvegarde dashlet de type liste
    useEffect(function () {
        if (settings.saved) {
            var currentRowId_1 = "";
            var currentRowMeta_1 = [];
            Object.values(metaDashletLayout).map(function (elem) {
                elem === null || elem === void 0 ? void 0 : elem.meta.map(function (melem) {
                    if (melem.id === settings.id) {
                        currentRowId_1 = elem.id;
                        currentRowMeta_1 = elem.meta;
                    }
                });
            });
            var currentDashlet_1 = Object.values(currentRowMeta_1).map(function (item) {
                if (item.id === settings.id) {
                    return __assign(__assign({}, item), { title: settings.dashlet.title, refresh: settings.dashlet.refresh, view_defs: settings.dashlet.view_defs, displayRows: settings.dashlet.displayRows, filters: settings.dashlet.filters, myItems: settings.dashlet.myItems });
                }
                else {
                    return item;
                }
            });
            var newDashlets = Object.values(metaDashletLayout).map(function (row) {
                if (row.id === currentRowId_1) {
                    return __assign(__assign({}, row), { meta: __spreadArray([], currentDashlet_1, true) });
                }
                else {
                    return row;
                }
            });
            var response = saveModuleBuilderLayoutMutation({
                moduleName: settings.module,
                layout: "dashletViewDefs",
                body: {
                    package: "default",
                    content: settings.dashlet.view_defs,
                    publish: true,
                },
            }).unwrap();
            updateDashletPreference(newDashlets);
            editedSettings(initialSettings);
        }
    }, [settings]);
    var _o = useState("tab1"), activeTab = _o[0], setActiveTab = _o[1];
    // Ajout nouvelle ligne
    var newLineProcess = function () {
        var line = {
            id: uuidv4(),
            meta: [],
        };
        var metaCopy = copy(Object.values(metaDashletLayout));
        metaCopy.unshift(line);
        //setMetaDashletLayout({ ...metaCopy });
        updateDashletPreference(__assign({}, metaCopy));
    };
    var _p = useState([]), currentRow = _p[0], setCurrentRow = _p[1];
    var addDashletToRow = function (id) {
        setCurrentRow({ id: id });
        setIsSelected(true);
    };
    // Suppression d'une ligne
    var removeRow = function (id) {
        if (window.confirm(String(t("app.LBL_REMOVE_DASHLET_LINE_CONFIRM", { ns: "common" })))) {
            var newMetaDaslets = Object.values(metaDashletLayout).filter(function (row) {
                return row.id !== id;
            });
            //setMetaDashletLayout(newMetaDaslets);
            updateDashletPreference(newMetaDaslets);
        }
        return;
    };
    // Mise à jour après drag and drop
    var updateAfterDrag = function (metadata) {
        updateDashletPreference(metadata);
    };
    var dashletContextValue = useMemo(function () { return ({ settings: settings, editedSettings: editedSettings }); }, [settings, editedSettings]);
    return (_jsxs("div", { children: [_jsx("div", __assign({ className: !isSelected
                    ? "hidden"
                    : "absolute left-0 flex top-0 w-full h-full after:content-[''] after:bg-gray-300 after:z-[100] after:w-full after:h-full after:left-0 after:right-0 after:absolute after:opacity-90" }, { children: _jsx("div", __assign({ className: !isSelected
                        ? ""
                        : "flex flex-row justify-center mt-20 w-full h-full backdrop-blur-sm z-[101]" }, { children: _jsxs("div", __assign({ className: "relative z-20 bg-[var(--colors-body-bg-sec)] p-8 w-11/12 max-h-[35rem] max-w-[40rem] border border-gray-200 rounded-md flex flex-col my-8" }, { children: [_jsxs("div", __assign({ className: "flex space-x-1 mb-4 border-b-2 pb-1" }, { children: [_jsx("button", __assign({ className: "py-2 px-2 rounded ".concat(activeTab === "tab1"
                                            ? "bg-[var(--colors-tab-selected)] text-[var(--colors-label)]"
                                            : "  bg-[var(--colors-body-bg)]"), onClick: function () { return setActiveTab("tab1"); } }, { children: _jsx("h2", __assign({ className: "font-bold uppercase" }, { children: t("LBL_MODULES", { ns: "Home" }) })) })), _jsx("button", __assign({ className: "py-2 px-4 rounded ".concat(activeTab === "tab2"
                                            ? "bg-[var(--colors-tab-selected)]  text-[var(--colors-label)]"
                                            : "  bg-[var(--colors-body-bg)]"), onClick: function () { return setActiveTab("tab2"); } }, { children: _jsx("h2", __assign({ className: "font-bold uppercase" }, { children: t("LBL_CHARTS", { ns: "Home" }) })) }))] })), _jsx("div", __assign({ className: "flex-none mb-4" }, { children: _jsx("span", __assign({ className: "absolute text-[var(--colors-label)] right-4 top-4 hover:text-gray-500 cursor-pointer", onClick: function (e) {
                                        setIsSelected(false);
                                    } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M6 18L18 6M6 6l12 12" }) })) })) })), activeTab === "tab1" && (_jsx("div", __assign({ id: "moduleDashlets", className: "overflow-x-auto" }, { children: dashletList && dashletList.length > 0 && (_jsxs("div", __assign({ style: { display: "flex" } }, { children: [_jsx("div", __assign({ style: { display: "flex", flexDirection: "column" } }, { children: dashletList.map(function (e, i) {
                                                return Object.values(e)
                                                    .filter(function (e, i) { return i % 2 === 0; })
                                                    .map(function (r) { return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "bg-gray-400 hover:bg-gray-300 py-4 uppercase m-1 pl-2 flex flex-1 overflow-hidden" }, { children: _jsxs("span", __assign({ className: "truncate cursor-pointer", onClick: function (e) {
                                                                addNewDashletPreference(r.module_name, "list");
                                                            } }, { children: [_jsx(FontAwesomeIcon, { icon: IconMappingModule["".concat(r.module_name)]
                                                                        ? IconMappingModule["".concat(r.module_name)]
                                                                        : faSquare, className: "mr-2 text-md" }), r.title] })) })) })); });
                                            }) })), _jsx("div", __assign({ style: { display: "flex", flexDirection: "column" } }, { children: dashletList.map(function (e, i) {
                                                return Object.values(e)
                                                    .filter(function (e, i) { return i % 2 !== 0; })
                                                    .map(function (r) { return (_jsx("div", __assign({ className: "bg-gray-400 hover:bg-gray-300 py-4 uppercase m-1 pl-2 flex flex-1 overflow-hidden" }, { children: _jsxs("span", __assign({ className: "truncate cursor-pointer", onClick: function (e) {
                                                            addNewDashletPreference(r.module_name, "list");
                                                        } }, { children: [_jsx(FontAwesomeIcon, { icon: IconMappingModule["".concat(r.module_name)]
                                                                    ? IconMappingModule["".concat(r.module_name)]
                                                                    : faSquare, className: "mr-2 text-md" }), r.title] })) }))); });
                                            }) }))] }))) }))), activeTab === "tab2" && (_jsx("div", __assign({ className: "overflow-y-auto" }, { children: _jsx(ChartsList, { addNewDashletPreference: addNewDashletPreference }) })))] })) })) })), _jsx(DashletContext.Provider, __assign({ value: dashletContextValue }, { children: settings.isSelected && (_jsx(EditDashlet, { showSettings: isEdit, dashlet: metaDashletLayout, onChange: onChange })) })), _jsxs("div", __assign({ className: "w-full relative" }, { children: [(dashletLoad || loadGetDashlet) && _jsx(LoaderImage, {}), _jsx("div", __assign({ className: "flex flex-row justify-between mt-2 mx-4" }, { children: _jsxs("div", __assign({ className: "flex flex-row my-2" }, { children: [_jsx("h1", __assign({ className: "uppercase font-bold" }, { children: t("app.LBL_SUITE_DASHBOARD", { ns: "common" }) })), _jsx("button", __assign({ className: "cursor-pointer ml-2 hover:text-gray-300", onClick: function () {
                                        newLineProcess();
                                    }, title: String(t("app.LBL_ADD_LINE", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faAdd, className: "text-md" }) }))] })) })), _jsx("div", { children: _jsx(DashletContext.Provider, __assign({ value: dashletContextValue }, { children: _jsx(RowsDashlet, { meta: metaDashletLayout, isNewRow: addDashletToRow, isRemoveRow: removeRow, updateAfterDrag: updateAfterDrag }) })) })] }))] }));
}
widgetsDictionary.register("widget/home/dashboard", {
    name: "Home dashboard",
    validation: true,
    display: memo(Dashboard),
    selectable: false,
});
